import type { NextPage } from 'next';
import Grid from '@mui/material/Grid';
import { Policy } from '../auth/Policy';
import { Typography } from '@mui/material';
import CompanyButton from './CompanyButton';

import logoEfigas from '../../public/images/Logo_efigas_full.svg';
import logoGascaribe from '../../public/images/Logo_Gases_Two_lines.svg';
import logoGuajira from '../../public/images/Logo_gases_guajira_full.svg';

enum CompanyEnum {
  gascaribe = 'gascaribe',
  efigas = 'efigas',
  gasguajira = 'gasguajira',
}

interface User {
  name: string;
  roles: string[];
}

const companyLogos: Record<CompanyEnum, string> = {
  [CompanyEnum.gascaribe]: logoGascaribe,
  [CompanyEnum.gasguajira]: logoGuajira,
  [CompanyEnum.efigas]: logoEfigas,
};

interface CompanyOption {
  path: string;
  role?: string;
}

interface CompanySelectorProps {
  user: User | null;
  options: Partial<Record<CompanyEnum, CompanyOption>>;
  style?: {
    color?: string;
    fontWeight?: string;
  };
}

const CompanySelectorComponent: NextPage<CompanySelectorProps> = ({
  user,
  options,
  style = {},
}) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      marginTop={5}
      spacing={3}
    >
      <Grid size={12}>
        <Typography
          fontSize={30}
          align="center"
          fontWeight={style.fontWeight || 'medium'}
          color={style.color}
        >
          Seleccione su gasera:
        </Typography>
      </Grid>
      {Object.entries(options).map(([key, option]) => {
        if (!option) {
          return null;
        }
        return (
          <Policy
            user={user}
            roles={option.role ? [option.role] : []}
            key={key}
          >
            <Grid>
              <CompanyButton
                path={option.path}
                src={companyLogos[key as CompanyEnum]}
                alt={key}
              />
            </Grid>
          </Policy>
        );
      })}
    </Grid>
  );
};

export default CompanySelectorComponent;
